import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Modal, Form, Select, DatePicker, Button, message } from "antd";
import { DollarCircleOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";

const CashierCheckModal = forwardRef((props, ref) => {
  const { selectedList = [], onSuccess } = props;
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  // 从 URL 读取 batchGroup:Module 进来没有,Batch 进来才有
  const bg = new URLSearchParams(location.search).get("batchGroup");
  const batchGroup = bg ? Number(bg) : undefined;

  const canPrintAll = commonFn.btnAuthorityFlag("PrintAll");

  const countOptions = [
    ...(selectedList.length
      ? [{ value: "1", label: `To Print selected ${selectedList.length} Transaction(s).` }]
      : []),
    ...(canPrintAll
      ? [{ value: "2", label: "Print all approved transactions." }]
      : []),
  ];

  useImperativeHandle(ref, () => ({
    open: async () => {

       if (!selectedList.length) {
    message.warning("Please select at least one item.");
    return;
  }
      setOpen(true);
      setLoading(true);
      try {
        const cDate = await http.get(api.commonCurrentDate);
        form.setFieldsValue({
          transactionCount: selectedList.length ? "1" : "2",
          postedDate: dayjs(cDate),
        });
      } finally {
        setLoading(false);
      }
    },
  }));

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const printAll = values.transactionCount === "2";
      const params = {
        vendorPaymentIds: selectedList.map((item) => item.vendorPaymentId),
        postedDate: values.postedDate?.format("YYYY-MM-DD"),
        batchGroup: batchGroup ?? null, 
        printAll,
      };
      console.log("[CashierCheck] submit params:", params);

      const response = await http.post(api.getPrintCashierCheck, params);
      if (response?.code === "1") {
        message.success("Print Cashier Check Success.");
        handleCancel();
        onSuccess?.(response);
      } else {
        commonFn.modalFailedFn(response);
      }
    } catch (e) {
      // 表单校验失败,无需处理
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <div style={{ fontSize: 24, fontWeight: "bold", color: "#dd4b39" }}>
          <DollarCircleOutlined style={{ marginRight: 8 }} />
          PRINT CASHIER CHECK CONFIRMATION
          <div style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}></div>
        </div>
      }
      open={open}
      centered
      width="40%"
      maskClosable={false}
      forceRender
      onCancel={handleCancel}
      footer={
        <div style={{ textAlign: "center" }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" loading={loading} onClick={handleOk} style={{ marginLeft: 12 }}>
            OK
          </Button>
        </div>
      }
    >
      <Form form={form} layout="horizontal" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
        <div style={{ margin: "16px 0 24px", fontSize: 20, textAlign: "center" }}>
          Are you sure you want to print these cashiers check(s)?
        </div>

        <Form.Item name="transactionCount" label="How Many Transactions?" rules={[{ required: true }]}>
          <Select options={countOptions} />
        </Form.Item>

        <Form.Item
          name="postedDate"
          label="Post Date"
          rules={[{ required: true, message: "Please select a date" }]}
        >
          <DatePicker
            style={{ width: "100%" }}
            format="MM/DD/YYYY"
            disabled={!commonFn.btnAuthorityFlag("ChangePrintPostDate")}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
});

export default CashierCheckModal;